import React, { useState, useEffect } from 'react';
import '../../styles/App.css';
import config from '../../config.json';
import MessageSummary from './messages/MessageSummary';

const DashboardContent = ({ user }) => {
    const [frequencyData, setFrequencyData] = useState([])
    const [summaryData, setSummaryData] = useState([])
    const [timeOfDayData, setTimeOfDayData] = useState([])

    useEffect(() => {
        Promise.all([
            fetch(config.api_url + "/messages/api/frequency/" + 1367 + ".json", {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwt')}`
                }
            }).then(value => value.json()),
            fetch(config.api_url + "/messages/api/summary.json?contact_id=" + 1367, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwt')}`
                }
            }).then(value => value.json()),
            fetch(config.api_url + "/messages/api/timeOfDay/" + 1367 + ".json", {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwt')}`
                }
            }).then(value => value.json())
        ]).then(([frequency, summary, timeOfDay]) => {
            setFrequencyData(frequency)
            setSummaryData(summary)
            setTimeOfDayData(timeOfDay)
        }).catch((err) => {
            console.log(err)
        });
    }, [user])

    return (
        <div>
            {frequencyData && Object.keys(summaryData).length > 0 &&
            <div className='container container-dashboard'>
                <section>
                    <MessageSummary
                        user={user}
                        summaryData={summaryData}
                        frequencyData={frequencyData}
                        timeOfDayData={timeOfDayData}
                    />
                </section>
            </div>}
        </div>
    )
}

export default DashboardContent;
